<template>
    <v-col cols="12" class="MyContract mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <h2 class="font-weight-medium">Mis Contratos</h2>
                     <v-row align="center" class="caption">
                         <v-col cols="12" lg="5" class="d-flex align-center">
                             <v-btn text><v-icon>mdi-dip-switch</v-icon> Filtros</v-btn>
                            <span>Ver: </span>
                            <v-btn text>Todas <v-icon color="green">mdi-check-box-outline</v-icon></v-btn>
                            <v-btn text>Aprobadas <v-icon>mdi-check-box-outline</v-icon></v-btn>
                            <v-btn text>Rechazadas <v-icon>mdi-check-box-outline</v-icon></v-btn>
                        </v-col>   
                         
                         <v-spacer></v-spacer>
                         <v-col cols="12" lg="5" class="d-flex align-center justify-end">
                            <v-text-field
                                    class="buscador tipo1"
                                    placeholder="Buscar en"
                                    outlined
                                    append-icon="mdi-magnify"
                            ></v-text-field>
                         </v-col>
                    </v-row>
                    <v-data-table
                            :headers="contracts.headers"
                            :items="contracts.data"
                            :items-per-page="5"
                            item-key="code"
                            class="elevation-1"
                            :search="contracts.search"
                            dense
                            show-select
                            :item-class="classColorReturn"
                    >

                        <template v-slot:item.TimeBlocks="{ item }">
                            <v-col class="d-inline-flex">
                                <v-chip v-for="(block,key) in item.TimeBlocks"
                                        class="ma-1"
                                        :color="block === 'A' ? '#004E85': block === 'B' ? '#FF9A1B' : block === 'C' ? '#0172C0' : 'grey'  "
                                        label
                                        dense
                                        :key="item.code+'-'+key"
                                        small
                                        text-color="white"
                                >
                                    {{block}}
                                </v-chip>
                            </v-col>
                        </template>
                        <template v-slot:item.SupplierInfo="{ item }">
                            <v-col class="d-inline-flex">
                                <v-icon color="grey">
                                    mdi-clock-time-four-outline
                                </v-icon>
                                <v-icon color="grey">
                                    mdi-information-outline
                                </v-icon>
                            </v-col>
                        </template>
                        <template v-slot:item.Contract="{ item }">
                            <v-btn
                                   raised
                                   :color="item.Contract.color"
                                   small
                                   dark
                                   class="">{{item.Contract.text}}</v-btn>
                        </template>

                    </v-data-table>
                    <v-btn color="primary"
                           raised
                           outlined
                           class="px-6 mt-4">Imprimir</v-btn>
                 
                </v-card>
            </v-col>

        </v-row>
    </v-col>
</template>
<style>
    .rotateTh > span{
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }
</style>
<script>
    export default {
        name: 'MyContract',
        data() {
            return {
                
                contracts:{
                    search:'',
                    headers: [
                        { text: 'Código', value: 'code' },
                        { text: 'Suministrador', value: 'supplier' },
                        { text: 'Precio Energia (USD/MWh)', value: 'EnergyPrice' },
                        { text: 'Precio Potencia (USD/MW-mes', value: 'PricePower' },
                        { text: 'Cuenta Mensual (USD)', value: 'MonthlyAccount' },
                        { text: 'Periodo de suministro (Meses)', value: 'SupplyPeriod' },
                        { text: 'Bloques Horarios', value: 'TimeBlocks' },
                        { text: 'Tipo de Tecnoloigia', value: 'TypeOfTechnology' },
                        { text: 'Info del Suministrador', value: 'SupplierInfo' },
                        { text: 'Diferencia (USD)', value: 'DifferenceUSD' },
                        { text: 'Contrato', value: 'Contract' },

                    ],
                    data: [
                        {
                            color:'',
                            code: 'A-1008',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                            Contract: {
                                color:'green',
                                text:'Ver detalles'
                            }
                        },
                        {
                            color:'',
                            code: 'A-1011',
                            supplier: 'San Andres SpA',
                            EnergyPrice:'30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: 6,
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:null,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                            Contract: {
                                color:'red',
                                text:'Ver detalles'
                            }
                        },
                    ]
                }
            }
        },
        methods:{
            classColorReturn(item){
                return item.color ? item.color : 'white';
            }
        },
        created: function () {
            this.$emit('SetcolorMenu', '#FE9A00');
        }

    }
</script>